module.exports = __webpack_public_path__ + "img/Chivas Regal 12 x Ferrari.5afe3dd1.png";